var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "statistics-cell",
      class: { selected: _vm.category === _vm.selectedCategory },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("select", _vm.category)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }